import React, { forwardRef } from 'react';
import { Grid, Typography, Theme, makeStyles, IconButton } from '@material-ui/core';
import CancelSharp from '@material-ui/icons/CancelSharp';

interface FilterLayoutProps {
  isVisible: boolean;
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  error?: string;
}

const FilterLayout = forwardRef<HTMLDivElement, FilterLayoutProps>(
  ({ children, isVisible, title, onClose, error }, ref) => {
    const classes = useStyles();

    if (!isVisible) return null;

    return (
      <Grid item xs={12} data-testid="filter-layout">
        <div
          ref={ref}
          className={`${classes.dialogContentPaper} ${error ? classes.errorPaper : ''}`}
        >
          <Grid
            container
            item
            justifyContent="space-between"
            alignItems="center"
            xs={12}
            className={classes.headerContainer}
          >
            <Grid item>
              <Typography variant="h6" classes={{ root: classes.h6 }}>
                {title}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={onClose} color="primary" aria-label="remove filter">
                <CancelSharp fontSize="small" style={{ color: 'rgba(0, 0, 0, 0.56)' }} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container item xs={12}>
            {children}
          </Grid>
          {error && (
            <Typography color="error" variant="caption" className={classes.errorText}>
              {error}
            </Typography>
          )}
        </div>
      </Grid>
    );
  }
);

const useStyles = makeStyles<Theme>((theme) => ({
  dialogContentPaper: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: theme.spacing(2),
    scrollMarginTop: '16px',
  },
  errorPaper: {
    border: `1px solid ${theme.palette.error.main}`,
  },
  errorText: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  headerContainer: {
    marginBottom: theme.spacing(2),
  },
  h6: {
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '120%',
    letterSpacing: '0.15px',
  },
}));

export default FilterLayout;
